export default __webpack_public_path__ + "static/media/arrow_forward.e1cf0a8b.svg";